const buttonTexts = [
    {
        title: "Products",
        subtitle: "Browse for products",
        link: "/products",
    },
    {
        title: "My Cart",
        subtitle: "See my cart",
        link: "/cart",
    },
    {
        title: "My Orders",
        subtitle: "Check your orders",
        link: "myorders/",
    },
    {
        title: "Products",
        subtitle: "Manage your products",
        link: "admin/products",
    },
    {
        title: "Orders",
        subtitle: "Manage your orders",
        link: "admin/orders",
    },
    {
        title: "Users",
        subtitle: "Manage users",
        link: "admin/users",
    },
]

export default buttonTexts;